import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import authReducer from "./authReducer";
import thunkMiddleWare from "redux-thunk";
import productTypesReducer from "./productTypesReducer";
import productReducer from "./productReducer";
import blogReducer from "./blogReducer";
import salesReducer from "./salesReducer";
import usersReducer from "./usersReducer";

let reducers=combineReducers({
    authPage:authReducer,
    blogPage:blogReducer,
    salesPage:salesReducer,
    productTypesPage:productTypesReducer,
    productPage:productReducer,
    usersPage:usersReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunkMiddleWare)));

// let store=createStore(reducers, applyMiddleware(thunkMiddleWare));
window.__store=store;
export default store;
